import { create } from "zustand";

import type { CurrentUserType, UserOrgTypeRoleType } from "api/user/types";

import type { PermissionsType } from "./permissions";

export type UserStore = {
  token: string | null;
  setToken: (token: string | null) => void;
  user: CurrentUserType | null;
  setUser: (user: CurrentUserType) => void;
};

const useUserStore = create<UserStore>()((set, _get) => ({
  token: null,
  setToken: (val) => {
    set({ token: val });
  },
  user: null,
  setUser: (val) => {
    set({ user: val });
  },
}));

// for debugging
// useUserStore.subscribe(console.log);

const hasPermissions = (
  requiredPermissions: PermissionsType | PermissionsType[] | undefined,
) => {
  // when there are requiredPermission
  if (requiredPermissions !== undefined) {
    // get userPermissions
    const userPermissions = useUserStore.getState().user?.Permissions;

    // if user has permissions available, check requirements
    if (userPermissions) {
      if (Array.isArray(requiredPermissions)) {
        return requiredPermissions.every((rp) => userPermissions.includes(rp));
      }
      return userPermissions.includes(requiredPermissions);
    }
    return false;
  }
  // when requiredPermissions are undefined, just return true
  return true;
};

const hasRole = (
  orgTypeRoles: UserOrgTypeRoleType | UserOrgTypeRoleType[] | undefined,
) => {
  // when there are requiredPermission
  if (orgTypeRoles !== undefined) {
    const userOrgType =
      useUserStore.getState().user?.UserV2?.organization?.Type;
    const userRole = useUserStore.getState().user?.UserV2?.user?.role;

    if (userOrgType && userRole) {
      if (Array.isArray(orgTypeRoles)) {
        if (!orgTypeRoles.length) {
          return true;
        }

        return orgTypeRoles.some((otr) => otr === `${userOrgType}-${userRole}`);
      }
      return orgTypeRoles === `${userOrgType}-${userRole}`;
    }
    return false;
  }
  return true;
};

const isVesselOwnerUser = () => {
  return hasRole([
    "vesselOwner-vesseluser",
    "vesselOwner-admin",
    "vesselOwner-standard",
  ]);
};

export { useUserStore, hasPermissions, hasRole, isVesselOwnerUser };
